import React, { useEffect, useState } from 'react';
import Picture from '../Picture';
import { BnIcon } from '../icons_v2';
import { Icons } from '../../types/theme';
import { IOptionImage } from '../../types';

const THUMBNAIL_CLASSNAME = 'option-thumbnail';

interface IOptionThumbnailProps {
	image: IOptionImage;
	alt: string;
}

/**
 * Leading thumbnail of an option row. Falls back to a placeholder icon when the option has no image
 * or the image fails to load, so every row in a list keeps the same height and alignment.
 */
export const OptionThumbnail = ({ image, alt }: IOptionThumbnailProps) => {
	const [hasError, setHasError] = useState(false);

	useEffect(() => setHasError(false), [image.url]);

	if (!image.url || hasError) {
		return (
			<div className={THUMBNAIL_CLASSNAME} data-testid="select-option-thumbnail-placeholder">
				<BnIcon icon={Icons.image} />
			</div>
		);
	}

	return (
		<div className={THUMBNAIL_CLASSNAME}>
			<Picture
				key={image.url}
				path={image.url}
				alt={image.alt ?? alt}
				onError={() => setHasError(true)}
				data-testid="select-option-thumbnail"
			/>
		</div>
	);
};
